<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

const authStore = useAuthStore()
const route = useRoute()

// Dashboard routes use DashboardLayout (their own layout), so don't wrap in DefaultLayout
const isDashboard = computed(() => route.path.startsWith('/dashboard'))

onMounted(async () => {
  // Check auth status on app load
  await authStore.checkAuth()
})
</script>

<template>
  <DefaultLayout v-if="!isDashboard">
    <RouterView />
  </DefaultLayout>
  <RouterView v-else />
</template>
